export default __webpack_public_path__ + "static/media/p7-5.502df422.png";